import React from "react";
import Header1 from "./../Header/Header1";
import Careers from "./Careers";
import FooterMain from "../Footer/FooterMain";
import SmallSnackBar from "./../SmallSnackBar/SmallSnackBar";
import ScrollToTop from "../ScrollToTop/ScrollToTop";
import WhatsAppButton from "../Whatsapp/WhatsappButton";

function CareersMain() {
  return (
    <div>
      <SmallSnackBar />
      <Header1 />
      <Careers />
      <FooterMain />
      <WhatsAppButton />
      <ScrollToTop />
    </div>
  );
}

export default CareersMain;
